import React from 'react';

const SkeletonCard = () => (
    <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700/50 animate-pulse">
        <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-gray-700"></div>
            <div>
                <div className="h-4 bg-gray-700 rounded w-24 mb-2"></div>
                <div className="h-3 bg-gray-700 rounded w-16"></div>
            </div>
        </div>
        <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-5/6 mb-4"></div>
        <div className="aspect-w-16 aspect-h-9 bg-gray-700 rounded-lg"></div>
    </div>
);

const FeedSkeleton = () => {
    return (
        <div className="space-y-4">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
        </div>
    );
};

export default FeedSkeleton;
